export default __webpack_public_path__ + "static/media/23-237430_html5-logo-graphic-design-hd-png-download.0317c70c.png";